import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

/** Read-only notes block for detail pages (card layout). */
@Component({
    selector: 'app-detail-notes-display',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoPipe],
    templateUrl: './detail-notes-display.component.html',
    styleUrl: './detail-notes-display.component.scss',
})
export class DetailNotesDisplayComponent {
    readonly note = input<string | null>(null);
    /** Transloco key for the section title (default matches Figma “Notes”). */
    readonly titleKey = input<string>('notes');
    /** Transloco key when `note` is empty or whitespace. */
    readonly emptyKey = input<string>('notSet');
    /** Stable id for the heading (`aria-labelledby`). Must be unique per page if multiple instances. */
    readonly headingId = input<string>('detail-notes-heading');

    readonly hasNote = computed(() => (this.note()?.trim() ?? '') !== '');
}
